import { DocumentType, DocumentTypeValue } from '#root/models/Shipping';

/**
 * Valida el número de documento según su tipo (misma regla que el backend):
 * DNI = 8 dígitos, CE = 9 a 12 dígitos.
 * Devuelve el mensaje de error, o '' si es válido o todavía está vacío.
 */
const validateDocNumber = (type: DocumentTypeValue, number: string): string => {
  if (!number) return '';

  if (type === DocumentType.dni) {
    if (!/^\d+$/.test(number)) return 'Solo números';
    if (number.length !== 8) return 'DNI debe tener 8 dígitos';
  } else if (type === DocumentType.ce) {
    if (!/^\d+$/.test(number)) return 'Solo números';
    if (number.length < 9 || number.length > 12) return 'CE debe tener entre 9 y 12 dígitos';
  }
  return '';
};

/** Documento completo y válido (vacío no cuenta como válido). */
export const isValidDocNumber = (type: DocumentTypeValue, number: string): boolean =>
  !!number && !validateDocNumber(type, number);

export default validateDocNumber;
